import { rem } from 'polished'
import styled from 'styled-components'

export const WithUserTooltipStyled = styled.div`
  font-size: ${rem(16)};

  .profile-info {
    padding: 1em;
  }
`
